import { useMutation } from "@apollo/client";

import {
  UpdateBeneficiaryGiftingCodeMutation,
  UpdateBeneficiaryGiftingCodeMutationVariables,
} from "@ctypes";
import { UPDATE_BENEFICIARY_GIFTING_CODE } from "@graphql";

export const useUpdateBeneficiaryGiftingCode = () => {
  return useMutation<
    UpdateBeneficiaryGiftingCodeMutation,
    UpdateBeneficiaryGiftingCodeMutationVariables
  >(UPDATE_BENEFICIARY_GIFTING_CODE);
};
